<template>
  <Content class="pro-content">
    <img src="../assets/partners21_9.jpg" loading="lazy" />
    <Card class="content-wrapper" dis-hover>
      <h1 slot="title">{{ $t("partners") }}</h1>
      <i-col class="spin-col" v-if="$apollo.queries.partnerships.loading">
        <Spin fix>
          <Icon type="ios-loading" size="18" class="icon-load"></Icon>
          <div>{{ $t("loading") }}</div>
        </Spin>
      </i-col>
      <div v-else-if="partnerships.error" class="error apollo">{{ $t("error") }}</div>
      <Tabs size="small" type="card" ref="tabPane" v-else-if="partnerships && _i18n.locale === 'sh'">
        <TabPane :animated="false" v-for="item in partnerships" :key="item.id" :label="item.name_al">
          <Row type="flex">
            <partner-item
              v-for="partner in item.partners"
              :name="partner.name"
              :link="partner.link"
              :image="partner.image"
              :key="partner.id"
            />
          </Row>
        </TabPane>
        <!-- No result -->
      </Tabs>
      <Tabs size="small" type="card" ref="tabPane" v-else-if="partnerships && _i18n.locale === 'en'">
        <TabPane :animated="false" v-for="item in partnerships" :key="item.id" :label="item.name">
          <Row type="flex">
            <partner-item
              v-for="partner in item.partners"
              :name="partner.name"
              :link="partner.link"
              :image="partner.image"
              :key="partner.id"
            />
          </Row>
        </TabPane>
      </Tabs>
    </Card>
  </Content>
</template>
<style lang="scss">
.pro-content {
  img {
    width: 100%;
  }
  .content-wrapper {
    margin: 15px 0;
  }
  .partners-svg {
    margin: 20px 0;
  }
}
</style>

<script>
import PartnerItem from '../components/PartnerItem.vue';
import partnershipsQuery from '../graphql/Partners.gql';

export default {
  components: {
    PartnerItem,
  },
  data() {
    return {
      partnerships: null,
    };
  },
  methods: {
    renderByI18n(item, property) {
      if (this._i18n.locale === 'al') {
        return item[property];
      }
      return item[`${property}_al`];
    },
  },
  apollo: {
    partnerships: {
      manual: true,
      query: partnershipsQuery,
      result({
        data: {
          partnerships: { data },
        },
      }) {
        console.log(data);
        this.partnerships = data.map(item => ({
          id: item.id,
          ...item.attributes,
          partners: item.attributes.partners.data.map(partner => ({ id: partner.id, ...partner.attributes })),
        }));

        console.log(this.partnerships);
      },
    },
  },
};
</script>
